/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function sliderInit(){ 
  if(!$('.drawer-upsell').hasClass('flickity-enabled') && $('.drawer-upsell').length){
     $('.drawer-upsell').flickity({
      pageDots: false,
      cellAlign: 'center',
      wrapAround: true,
      draggable: false
    }); 
  }
}

setInterval(function(){
  sliderInit();  
});


let upsellAdd = (e) => {
  var id = e.getAttribute('data-var-id');
  var custom_Id = e.getAttribute('data-new-var-id');  
  var lineId = [];
  console.log(custom_Id, 'custom_Id');
  if(custom_Id != null && custom_Id != ''){
    
    const ids = custom_Id.split(',').filter(id => id);     
    ids.forEach((id, index) => {      
      const selector = `#boxItem-id${id}`;
      const element = document.querySelector(selector);
      if (element) {
        lineId.push(element.querySelector(".CartItem__Remove").getAttribute('data-var'));
      } 
    });    
  }
  
  let formData = {
    id : id,
    quantity:1
  };
 fetch('/cart/add.js', {
  method: 'POST',
  headers: {
  'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
  })
  .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true, 
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    
  });   

  if(lineId.length){
    const removeData = lineId.reduce((obj, arrValue) => (obj[arrValue] = 0, obj), {});
    console.log(removeData, 'removeData');
    $.ajax({
      type: 'POST',
      async: false,
      url: '/cart/update.js',
      data: { updates: removeData },
      dataType: 'json'
    });
  }
}

function addTocart(e){
  var items = [];
 
  var form = $(e.target.closest('form'));
  var selects = form.find('.select-input');
  var selectlength = selects.length;
  for(i=0; i<selectlength; i++){
      var select = selects[i];
      if(select.value != ''){
        items.push({"id": select.value, "quantity": 1});
      }
  }
  
  const combinedItems = (items = []) => {
   const res = items.reduce((acc, obj) => {
      let found = false;
      for (let i = 0; i < acc.length; i++) {
         if (acc[i].id === obj.id) {
            found = true;
            acc[i].quantity++;
         };
      }
      if (!found) {
         obj.quantity = 1;
         acc.push(obj);
      }
      return acc;
   }, []);
   return res;
  }
  items = combinedItems(items);
  
  const data = {
  	items: items
  }
  console.log(data);
  
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', false);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);
      //window.location.href = '/checkout';
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
        detail: {
          quantity: 1
        }
      }));
        
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
      }));

   if(form.find('.discountCode').length){
        setTimeout(function(){
          fetch('/discount/' + form.find('.discountCode').val(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }).then(response => {
            if (response.ok) {
              //location.reload(); // Reload the page to show the discount applied
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                 bubbles: true
              }));
            }
          });
        },1500);
      }
      
    }
  };
  xhr.send(JSON.stringify(data));
}

let atcEvent = (e) => {
  var id = e.target.getAttribute('data-var-id');
  let formData = {
    id : id,
    quantity:1
  };
 fetch('/cart/add.js', {
  method: 'POST',
  headers: {
  'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
  })
  .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true,
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  });

      
}
var atc = document.querySelectorAll('.collection-atc');
atc.forEach((item) => {
  item.addEventListener('click', atcEvent)
});


// Remove shipping bar when discount code is added.
setInterval(checkDiscount, 1000);
function checkDiscount() {
  var discountAdded = document.querySelector('.docapp-coupon-input--bean-container--bean');
  var shipText = document.getElementById('Cart__ShippingNotice');
  if(discountAdded){
    var discountCode = document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove')[0].getAttribute('data-code');
    if(discountCode == 'MIJNFAVORIET'){
      if(shipText){
        shipText.style.display = 'none';
      }else{
        shipText.style.display = 'block';
      }
    }
  }else{
    shipText.style.display = 'block';
  }
}

let buttons = document.querySelectorAll('.add-to-cart-link');
buttons.forEach(button => {
  button.addEventListener('click', addTocart);
});

$(window).on('load', function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const section = urlParams.get('make-up-routine');
  if(section){
     $('html, body').animate({
        scrollTop: $("div#shopify-section-template--18871117644099__328a5b80-cf37-4c42-a6e6-63968d41372a").offset().top
    }, 400);
  }
   
  });

$('body').on('click', '.collection-top-block .tab', function(){
    var target = $(this).attr('data-target');
    $('html, body').animate({
        scrollTop: $("div[data-handle='"+target+"']").offset().top - $('#section-header').innerHeight() - 10
    }, 1000);

});

if(window.innerWidth < 749){
  $('.icons-bar.main-carousel').flickity({
    autoPlay: 4000,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: false
  });
}

function openKlaviyo(formId) {
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', formId]);  
}

var urlParams = new URLSearchParams(window.location.search);
var showPopup = urlParams.get('showPopup'); // true
if(showPopup){
    console.log(showPopup, 'showPopup');
    toggleModal('custom-modal');
}

$('body').on('change', '.bundle-wrapper .select-input', function(){ 
  var av = $('.select-input option[available="false"]:checked');
  var avBtnText = $('#add-to-cart-link').attr('data-btn-text');
  var soldBtnText = $('#add-to-cart-link').attr('data-sold-text');
  console.log('yees', av.length);
  if(av.length > 0){
     $('#add-to-cart-link').text(soldBtnText).prop('disabled', true);
  }else{
     $('#add-to-cart-link').text(avBtnText).prop('disabled', false);
  }
});


/* Quiz custom add to cart start */
//if($('body.page-quiz-lp').length || $('body.page-quiz').length){
  // Function to handle messages from the iframe
  window.addEventListener('message', (event) => {
      // Verify the origin of the message
      if (event.origin !== "https://admin.revenuehunt.com") {
          console.warn("Blocked message from untrusted origin:", event.origin);
          return;
      }
  
      // Validate and process the data
      const data = event.data;
      if (data && data.action === "callAjax" && data.id) {
        var found_in_cart = 0;
  
        $.ajax({
          url: '/cart.js',
          method: 'GET',
          dataType: 'json',
          async: false, // Synchronous behavior (not recommended)
          success: function(cart) {
            if (cart.items.some(e => e.id == data.id)) {
              found_in_cart = 1;
            }
          },
          error: function(xhr, status, error) {
            console.error('Error fetching cart:', error);
          }
        });
        
        console.log('Found in cart:', found_in_cart);
  
          if(found_in_cart){ console.log('opencart');
            openCart();
          }else{ console.log('sendAjaxRequest');
            sendAjaxRequest(data.id);
          }
      } else {
          //console.error("Invalid message received:", data);
      }
  });
  
  // The AJAX request function
  function sendAjaxRequest(id) {
      console.log(`AJAX request initiated from iframe with ID: ${id}`);
      var sendData = {
        id : id,
        quantity:1
      };
     fetch('/cart/add.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify(sendData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
          detail: {
            quantity: 1
          }
        }));
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      });
  }
  
  function openCart(){
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true,
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
  
//}
/* Quiz custom add to cart end */
